// removed by extract-text-webpack-plugin
module.exports = {"Main":"src-containers-Promo-__PromoPage-module___Main","AffixContent":"src-containers-Promo-__PromoPage-module___AffixContent","HighlightedItem":"src-containers-Promo-__PromoPage-module___HighlightedItem","HighlightedItemTitle":"src-containers-Promo-__PromoPage-module___HighlightedItemTitle","HighlightedItemTitleText":"src-containers-Promo-__PromoPage-module___HighlightedItemTitleText","AffixContentBorder":"src-containers-Promo-__PromoPage-module___AffixContentBorder","FormFilter":"src-containers-Promo-__PromoPage-module___FormFilter"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Promo/PromoPage.module.css
// module id = 1221
// module chunks = 1